import { AdTile, AdTileInt } from './types';

export const formatAdTile = (tile: AdTileInt): AdTile => ({
  ...tile,
  type: 'adTiles',
  id: tile.click_url,
  title: tile.name,
  url: tile.click_url,
});

export const getActivePartner = async (type: string) => {
  const config = (await chrome.storage.local.get('partnersConfig'))
    .partnersConfig;

  if (!config) return [];

  const { scheduleByAdType } = config;

  const schedule = scheduleByAdType[type];

  const day = new Date().getDay();

  const partner = schedule[day];

  return partner;
};

export const getPartnerRevenue = async (partner: string) => {
  let config;

  try {
    config = (await chrome.storage.local.get('partnersConfig')).partnersConfig;
  } catch (err) {
    // Get the config from the server
    config = await fetch(process.env.APP_URL + '/api/partners')
      .then((res) => res.json())
      .catch((err) => {
        console.error('partnersConfig', err);
        return null;
      });
  }

  if (!config) return 0;

  const { revenue } = config;

  return revenue[partner];
};
